import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { CalculatorsService } from '../calculators.service';
import { Observable, Subject } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonCalculatorComponent } from '../common-calculator/common-calculator.component';
import { DropdownComponent } from '@iv/shared/components/dropdown/dropdown.component';
import { getCurrentTab } from '@iv/store/tabs/tabs.selectors';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import { getHttpParams } from '@iv/shared/utils';
import { getAllFutures } from '@iv/store/futures/futures.reducer';
import { Tab } from '@iv/model/tabs.model';
import { replaceExclude } from 'app/calculators/helpers/calc.helpers';
import { PaymentWindowService } from '../../payment-window.service';
import { IProbabilityCalculatorResult } from "../models/probability-calculator-result";
import { Instrument } from "@iv/model/instrument";

@Component({
  selector: 'iv-live-probability-calculator',
  templateUrl: './probability-calculator.component.html',
  styleUrls: ['./probability-calculator.component.scss'],
})
// TODO: Привести в порядок названия методов и свойств
export class ProbabilityCalculatorComponent implements OnInit, OnChanges, OnDestroy {

  @Input() instrument;
  @Input() id;
  @Input() instruments = [];
  @Input() mode = 'eod';
  @Input() currentTab: Tab;
  @Input() stockId: string;

  @Output() closeButtonClicked = new EventEmitter<any>();
  @Output() showMessageEvent = new EventEmitter<any>();
  @Output() openDropdownEvent = new EventEmitter<any>();
  @Output() returnRegionEvent = new EventEmitter<any>();
  @Output() onInstrumentChange: EventEmitter<Instrument> = new EventEmitter<Instrument>();

  @ViewChild(CommonCalculatorComponent, {static: false}) commonCalculator !: CommonCalculatorComponent;
  @ViewChildren(DropdownComponent) dropdown: QueryList<DropdownComponent>;

  stockType: string;
  type = 'call';
  p1: any;
  p2: any;
  volas = {
    '1': {
      volaString: 'ATM Volatility',
      volaType: 'ATM',
      volaTerm: 0
    },
    '2': {
      volaString: 'IV Index 30D',
      volaType: 'IV',
      volaTerm: 30
    },
    '3': {
      volaString: 'IV Index 60D',
      volaType: 'IV',
      volaTerm: 60
    },
    '4': {
      volaString: 'IV Index 90D',
      volaType: 'IV',
      volaTerm: 90
    },
    '5': {
      volaString: 'IV Index 120D',
      volaType: 'IV',
      volaTerm: 120
    },
    '6': {
      volaString: 'IV Index 150D',
      volaType: 'IV',
      volaTerm: 150
    },
    '7': {
      volaString: 'IV Index 180D',
      volaType: 'IV',
      volaTerm: 180
    },
    '8': {
      volaString: 'HV 10D',
      volaType: 'HV',
      volaTerm: 10
    },
    '9': {
      volaString: 'HV 30D',
      volaType: 'HV',
      volaTerm: 30
    },
    '10': {
      volaString: 'HV 60D',
      volaType: 'HV',
      volaTerm: 60
    },
    '11': {
      volaString: 'HV 90D',
      volaType: 'HV',
      volaTerm: 90
    },
    '12': {
      volaString: 'HV 120D',
      volaType: 'HV',
      volaTerm: 120
    },
    '13': {
      volaString: 'HV 150D',
      volaType: 'HV',
      volaTerm: 150
    },
    '14': {
      volaString: 'HV 180D',
      volaType: 'HV',
      volaTerm: 180
    }
  };
  volasDelayed = {
    '1': {
      volaString: 'ATM Volatility',
      volaType: 'ATM',
      volaTerm: 0
    },
    '2': {
      volaString: 'IV Index 30D',
      volaType: 'IV',
      volaTerm: 30
    },
    '3': {
      volaString: 'IV Index 60D',
      volaType: 'IV',
      volaTerm: 60
    },
    '4': {
      volaString: 'IV Index 90D',
      volaType: 'IV',
      volaTerm: 90
    },
    '5': {
      volaString: 'HV 10D',
      volaType: 'HV',
      volaTerm: 10
    },
    '6': {
      volaString: 'HV 30D',
      volaType: 'HV',
      volaTerm: 30
    },
    '7': {
      volaString: 'HV 60D',
      volaType: 'HV',
      volaTerm: 60
    },
    '8': {
      volaString: 'HV 90D',
      volaType: 'HV',
      volaTerm: 90
    },
    '9': {
      volaString: 'HV 120D',
      volaType: 'HV',
      volaTerm: 120
    },
    '10': {
      volaString: 'HV 150D',
      volaType: 'HV',
      volaTerm: 150
    },
    '11': {
      volaString: 'HV 180D',
      volaType: 'HV',
      volaTerm: 180
    }
  };
  calculateP1: number;
  calculateP2: number;
  calculateBetween;
  calculateBelow;
  calculateAbove;
  calculateNegativeStd1: number;
  calculateNegativeStd2: number;
  calculateNegativeStd3: number;
  calculateStd1: number;
  calculateStd2: number;
  calculateStd3: number;
  calculateBoth: number;
  calculateEither: number;
  calculateNeither: number;
  dividendFrequencyName = ' ';
  frequencies = {
    '1': {
      name: 'Annually',
      value: '1'
    },
    '2': {
      name: 'Semiannually',
      value: '2'
    },
    '4': {
      name: 'Quarterly',
      value: '4'
    },
    '12': {
      name: 'Monthly',
      value: '12'
    }
  };
  parameters: any = {};
  isEod = false;
  price: any;
  priceStrike: any;
  expDate: any;
  futExpDate: string;
  rate: any;
  lastDividendDate: any;
  lastDividendAmount: any;
  dividendFrequency;
  _yield;
  daysToExp;
  result: any = {};
  regionId: any = 1;
  expirations = [];
  hours: any;
  minutes: any;
  error = null;
  _customDate = {
    expDate: 'Custom date',
    daysToExp: '',
    hours: '',
    minutes: ''
  };
  longExpDate: any;
  expTime: any;
  volaString: any;
  vola: any;
  volaTerm: any;
  volaType: any;
  _customVola = {
    volaString: 'Custom',
    volaType: '',
    volaTerm: 0
  };
  symbNotFound = false;
  public dateMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];
  public isLoading = false;
  public inputChanged: Subject<string> = new Subject<string>();
  isFuturesMonitor = getCurrentTab(this._store.getState()).type.includes('future');
  futureExpirations = [];

  constructor(
    private _calculatorsService: CalculatorsService,
    private spinner: NgxSpinnerService,
    @Inject(AppStore) private _store: Redux.Store<AppState>,

    private readonly paymentWindowService: PaymentWindowService
  ) {
  }

  onlyNumberKey(event) {
    // let charCode = (event.query) ? event.query : event.keyCode;
    // if (charCode > 31 && (charCode < 44 || charCode === 45 || charCode === 47 || charCode > 57)) {
    //   return false;
    // }
    // this.clearResult();
    // return true;
  }

  onlyNumbersPaste($event) {
    const input = $event.srcElement;
    const inputValue = parseFloat(input.value);

    if (input.dataset.id === 'rate') {
      input.value = input.value.replace(/\-{2,}|[^\d\.]\./g, '-').replace(/\.\-/g, '.').replace(/^[^\d\-]|[^\d\-.]|\b-/g, '').replace(/^0{2,}/g, '0').replace(/^\-0{2,}/g, '-0');
      if ((input.value.match(/\./g) !== null) && (input.value.match(/\./g).length > 1)) {
        input.value = input.value.substr(0, input.value.lastIndexOf('.'));
      }
    } else if (input.dataset.id === 'daysToExp' || input.dataset.id === 'hoursToExp' || input.dataset.id === 'minToExp') {
      input.value = input.value.replace(/\-{2,}/g, '-').replace(/[^0-9\-]|\b-/g, '');
    } else {
      input.value = input.value.replace(/[^0-9\.]|^\./g, '').replace(/^0{2,}/g, '0');
      if ((input.value.match(/\./g) !== null) && (input.value.match(/\./g).length > 1)) {
        input.value = input.value.substr(0, input.value.lastIndexOf('.'));
      }
    }

    function removeTooltip() {
      if (input.nextElementSibling !== null) {
        input.nextElementSibling.remove();
        input.style.borderColor = '';
      }
    }

    if ((inputValue < 0 || inputValue > 1000000) && !input.parentNode.classList.contains('time-values') && input.dataset.id !== 'rate' && input.dataset.id !== 'yield') {
      removeTooltip();
      input.style.borderColor = 'red';
      this.inputTooltip(input, 'Please enter a value between 0 and 1 000 000');
    } else if (!input.parentNode.classList.contains('time-values')) {
      removeTooltip();
    }
  }

  onScroll($event) {
    $event.scrollIntoView();
  }

  dateValidate($event) {
    const dateInput = $event.srcElement;
    const dateArr = dateInput.value.split('-');
    const month = Number(dateArr[1]);
    const day = Number(dateArr[2]);

    function removeTooltip() {
      if (dateInput.nextElementSibling !== null) {
        dateInput.nextElementSibling.remove();
        dateInput.style.borderColor = '';
      }
    }

    if ((month && month > 12) || (day && day > 31)) {
      removeTooltip();
      dateInput.style.borderColor = 'red';
      this.inputTooltip(dateInput, 'Please enter the date in the format yyyy-mm-dd');
    } else {
      removeTooltip();
    }
  }

  inputTooltip(elem, tooltipText) {
    const parent = elem.parentNode;
    parent.style.position = 'relative';
    parent.style.alignItems = 'center';
    const tooltip = document.createElement('div');
    const tooltipFigure = document.createElement('div');
    const tooltipContent = document.createElement('div');

    tooltip.classList.add('calc-input-tooltip');

    tooltip.style.cssText = `
      position: absolute;
      left: 100%;
      display: flex;
      z-index: 9999;
      height: 23px;
      margin-top: 2px;
    `;

    tooltipFigure.style.cssText = `
      border-right: 7px solid rgba(245, 97, 112, 0.8);
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      height: 10px;
      margin-top: 5px;
    `;

    tooltipContent.style.cssText = `
      background: rgba(245, 97, 112, 0.8);
      font-weight: 400;
      font-size: 12px;
      color: #fff;
      border-radius: 4px;
      line-height: 23px;
      padding: 0 10px;
      white-space: nowrap;
    `;

    tooltipContent.innerText = tooltipText;

    tooltip.appendChild(tooltipFigure);
    tooltip.appendChild(tooltipContent);
    parent.appendChild(tooltip);
  }

  keyDown(event) {
    const charCode = (event.query) ? event.query : event.keyCode;
    if (charCode === 8 || charCode === 127) {
      this.clearResult();
    }
  }

  keyDownSearch(event) {
    const inputFields = document.querySelectorAll('input.param-value');
    const inputTooltips = document.querySelectorAll('.calc-input-tooltip');
    if (inputTooltips) {
      inputTooltips.forEach((elem) => {
        elem.remove();
      });
    }
    inputFields.forEach((elem: HTMLElement) => {
      elem.style.borderColor = '';
    });

    const charCode = event.keyCode;
    if (charCode === 8 || (charCode > 31 && charCode < 128)) {
      this.clearResult();
      this._yield = null;
      this.daysToExp = null;
      this.price = null;
      this.dividendFrequencyName = null;
      this.priceStrike = null;
      this.expTime = null;
      this.dividendFrequencyName = null;
      this.expDate = null;
      this.rate = null;
      this.lastDividendAmount = null;
      this.lastDividendDate = null;
      this.minutes = null;
      this.hours = null;
      this.expirations.length = 0;
      this.vola = null;
      this.volaString = null;
    }
  }

  clearResult() {
    this.calculateP1 = null;
    this.calculateP2 = null;
    this.calculateBetween = null;
    this.calculateBelow = null;
    this.calculateAbove = null;
    this.calculateNegativeStd1 = null;
    this.calculateNegativeStd2 = null;
    this.calculateNegativeStd3 = null;
    this.calculateStd1 = null;
    this.calculateStd2 = null;
    this.calculateStd3 = null;
    this.calculateBoth = null;
    this.calculateEither = null;
    this.calculateNeither = null;
  }

  ngOnInit() {
    this.paymentWindowService.showPaymentWindow();
    this.isLoading = false;
    if (this.instrument) {
      this.id = this.isFuturesMonitor ? this.instrument.underlyingId ?? this.instrument.underlyingid : this.instrument.stockId ?? this.instrument.stockid;
    }
    if (this.isFuturesMonitor) {
      this.instruments = getAllFutures(this._store.getState());
      delete this.volasDelayed['5'];
    }
    this.inputChanged
      .debounceTime(2000)
      .distinctUntilChanged()
      .subscribe(() => this.calculate())
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (this.instrument) {
      this.id = this.isFuturesMonitor ? this.instrument.underlyingId ?? this.instrument.underlyingid : this.instrument.stockId ?? this.instrument.stockid;
    }
    if (this.isFuturesMonitor && this.currentTab) {
      this.futExpDate = this.currentTab.data.serviceTabs[0].filters.futExpDate;
    }
  }

  public ngOnDestroy() {
    this.commonCalculator.ngOnDestroy();
    this.clearAll();
  }

  onModeChanged($event: { isEod: boolean, instrument: string }) {
    this.id = $event.instrument;
    this.isEod = $event.isEod;
  }

  _getParameters($event: { isEod: boolean, id: string }) {
    return new Promise((resolve, reject) => {
      this.spinner.show('probabilityCalculatorSpinner');
      this.isLoading = true;
      this._calculatorsService.getProbabilityCalculatorParameters($event.id, this._isEod())
        .subscribe(response => {
          this.hideSpinner();
          if (response.status === 200) {
            const result = response.body;
            resolve(result);
          } else if (response.status === 400) {
            // this.error = response.statusText;
            reject();
          } else {
            reject();
          }
        });
    });
  }

  public hideSpinner(): void {
    if (this.isLoading) {
      this.isLoading = false;
      this.spinner.hide('probabilityCalculatorSpinner');
    }
  }

  getArrayFromObject(someObj) {
    if (!someObj) return;
    return Object.values(someObj);
  }

  getHoursMinutesToExp(): Observable<HttpResponse<any>> {
    return this._calculatorsService.getHoursMinutesToExp(
      this.longExpDate,
      this.isEod,
      this.id
    );
  }

  _getVolas(): Observable<HttpResponse<any>> {
    return this._calculatorsService.getVolaProbability(
      this.id,
      this.volaType,
      this.volaTerm,
      this._isEod(),
      this.expDate.expDate,
      this.expDate.daysToExp
    );
  }

  _getFutVoals() {
    return this._calculatorsService.getFutVolaProbability(getHttpParams({
      id: this.id,
      futExpDate: this.futExpDate,
      optExpDate: this.expDate?.expDate === this._customDate.expDate ? '' : this.expDate?.expDate,
      days: replaceExclude(this.expDate?.daysToExp),
      typeVola: this.volaType,
      term: this.volaTerm,
      isEod: `${this._isEod()}`
    }));
  }

  setVola(response: HttpResponse<any>): void {
    if (response.status === 200) {
      const result = response.body;
      this.vola = (result.vola).toFixed(2);
    } else if (response.status === 206) {
      this.result = response.body;
    } else {
      this.result = {};
    }
  }

  setExpiration(response: HttpResponse<any>): void {
    if (response.status === 200) {
      const result = response.body;
      this.hours = result.hours;
      this.minutes = result.minutes;
      this.expDate = {
        expTime: result.longExpDate.substring(11, 16),
        expDate: result.expDate.substring(0, 10),
        daysToExp: result.daysToExp,
        longExpDate: result.longExpDate,
        hours: result.hours,
        minutes: result.minutes
      };
    } else if (response.status === 206) {
      this.result = response.body;
    } else {
      this.result = {};
    }
  }

  onGoButtonClick($event: any) {
    if (
      !this.instrument?.hasOwnProperty('id') &&
      this.instrument?.underlyingId !== $event.id &&
      this.instrument?.stockId !== $event.id
    ) {
      this.instrument = this.instruments.find(value => value?.stockId === $event.id || value?.underlyingId === $event.id);
    }
    this.futExpDate = undefined;
    this._fillParameters({
      ...$event,
      id: this.instrument ? this.instrument.id ? this.instrument.id : $event.id : $event.id,
      optionCode: this.instrument && this.instrument[this.isFuturesMonitor ? 'underlyingId' : 'stockId']
    });
  }

  calculate() {
    if (this.id) {
      this.spinner.show('probabilityCalculatorSpinner');
      this.isLoading = true;
      if (this.isFuturesMonitor) {
        this._calculatorsService.getFutProbabilityCalculatorResult(getHttpParams({
          price: this.price ? replaceExclude(this.price) : '0',
          priceStrike: this.priceStrike ? replaceExclude(this.priceStrike) : '0',
          futExpDate: this.futExpDate,
          vola: replaceExclude(this.vola),
          rate: replaceExclude(this.rate),
          id: this.id,
          p1: replaceExclude(this.p1),
          p2: replaceExclude(this.p2),
          daysToExp: this.daysToExp,
          hoursToExp: this.hours,
          minutesToExp: this.minutes,
          isEod: String(this._isEod()),
          dividendType: this.stockType
        }))
          .subscribe(calculationResult => {
            this.hideSpinner();
            this.loadCalculationResult(calculationResult);
          },
            () => this.hideSpinner()
          );
      } else {
        this._calculatorsService.getProbabilityCalculatorResult(
          getHttpParams(
            {
              price: this.price != null ? this.price : undefined,
              expDate: this.expDate.expDate && this.expDate.expDate !== 'Custom date' && this.expDate.expDate !== ' ' ? `${this.expDate.expDate} 00:00` : undefined,
              daysToExp: this.daysToExp ? replaceExclude(this.daysToExp) : undefined,
              hoursToExp: this.hours ? replaceExclude(this.hours) : undefined,
              minutesToExp: this.minutes ? replaceExclude(this.minutes) : undefined,
              volaType: this.volaType,
              vola: this.vola ? replaceExclude(this.vola) : undefined,
              rate: this.rate != null ? replaceExclude(this.rate) : undefined,
              lastDividentDate: this.lastDividendDate,
              lastDividentAmount: this.lastDividendAmount != null ? replaceExclude(this.lastDividendAmount) : undefined,
              dividentFrequency: this.dividendFrequency,
              yield: this._yield,
              stockId: this.id,
              p1: this.p1 ? replaceExclude(this.p1) : undefined,
              p2: this.p2 ? replaceExclude(this.p2) : undefined,
              dividendType: this.stockType === 'I' || this.stockType === 'X' ? 'Yield' :
                (this.stockType === 'S' || this.stockType === 'F' ? 'Regular' : 'NoDividend'),
              isEod: String(this._isEod() ? this._isEod() : false)
            }
          )
        )
          .subscribe(calculationResult => {
            this.hideSpinner();
            this.loadCalculationResult(calculationResult);
          },
            () => this.hideSpinner()
          );
      }
    }
  }

  loadCalculationResult(calculationResult: IProbabilityCalculatorResult) {
    this.result = calculationResult;
    this.calculateP1 = this.result.p1;
    this.calculateP2 = this.result.p2;
    this.calculateBetween = (this.result.between * 100).toFixed(0).concat('%');
    this.calculateBelow = (this.result.below * 100).toFixed(0).concat('%');
    this.calculateAbove = (this.result.above * 100).toFixed(0).concat('%');
    this.calculateBoth = this.result.both;
    this.calculateEither = this.result.either;
    this.calculateNeither = this.result.neither;
    this.calculateNegativeStd1 = +this.result.negativeStd1.toFixed(+this.result.negativeStd1 > 1000 ? 0 : 2);
    this.calculateNegativeStd2 = +this.result.negativeStd2.toFixed(+this.result.negativeStd2 > 1000 ? 0 : 2);
    this.calculateNegativeStd3 = +this.result.negativeStd3.toFixed(+this.result.negativeStd3 > 1000 ? 0 : 2);
    this.calculateStd1 = +this.result.std1.toFixed(+this.result.std1 > 1000 ? 0 : 2);
    this.calculateStd2 = +this.result.std2.toFixed(+this.result.std2 > 1000 ? 0 : 2);
    this.calculateStd3 = +this.result.std3.toFixed(+this.result.std3 > 1000 ? 0 : 2);
  }

  symbolNotFound() {
    this.showMessageEvent.emit({message: 'Symbol not found', type: 'error'});
  }

  clearStock() {
    this.commonCalculator.stockName = null;
    this.commonCalculator._stockName = null;
    this.commonCalculator.stockSearchCriteria = null;
    this.instrument = undefined;
  }

  clearAll() {
    this.clearStock();
    this.clearResult();
    this.keyDownSearch({keyCode: 8});
  }

  selectFutExpiration($event: any) {
    this.clearResult();
    this.futExpDate = $event;
    this._fillParameters({
      id: this.id,
      isEod: this.isEod
    });
  }

  selectExpiration($event: any) {
    this.clearResult();
    this.expDate = {
      expTime: $event.longExpDate.substring(11, 16),
      expDate: $event.expDate.substring(0, 10),
      daysToExp: $event.daysToExp,
      hours: $event.hours,
      minutes: $event.minutes,
      longExpDate: $event.longExpDate
    };
    this.daysToExp = $event.daysToExp;
    this.hours = $event.hours;
    this.minutes = $event.minutes;
    this.longExpDate = $event.longExpDate;
    this.expTime = $event.longExpDate.substring(11, 16);
    if (!this.isFuturesMonitor) {
      this.getHoursMinutesToExp().subscribe(response => {
        this.setExpiration(response);
      });
      this._getVolas().subscribe(value => {
        this.setVola(value);
        this.getRate().subscribe(response => {
          this.rate = response.toFixed(4);
        });
      });
    } else {
      this._getFutVoals().subscribe(value => this.setVola(value));
    }
  }

  getRate(): Observable<number> {
    return this._calculatorsService.getRate(
      this.id,
      this.expDate.daysToExp
    );
  }

  selectVolaType($event: any) {
    this.clearResult();
    this.volaType = $event.volaType;
    this.volaTerm = $event.volaTerm;
    if (this.isFuturesMonitor) {
      this._getFutVoals().subscribe(value => this.setVola(value));
      return;
    }
    this._getVolas().subscribe(value => {
      this.setVola(value);
    });
    this.calculate()
  }

  selectFrequency($event: any) {
    this.clearResult();
    this.dividendFrequency = $event.value;
    this.calculate()
  }

  onExpValueInput($event, valueName: string) {
    this.onlyNumbersPaste($event);
    this[valueName] = $event.srcElement.value;
    this._selectCustomExpiration();
  }

  onVolaValueInput($event, valueName: string) {
    const input = $event.srcElement;
    input.value = input.value.replace(/[^0-9\.]|^\./g, '').replace(/^0{2,}/g, '0');
    if ((input.value.match(/\./g) !== null) && (input.value.match(/\./g).length > 1)) {
      input.value = input.value.substr(0, input.value.lastIndexOf('.'));
    }
    this.onlyNumbersPaste($event);
    this[valueName] = input.value;
    this._selectCustomVola();
  }

  getHours() {
    if (this.expDate) {
      return this.expTime;
    }
    return '';
  }

  public changeInstrument(instrument: Instrument): void {
    this.stockType = instrument.stockType;
    this.onInstrumentChange.emit(instrument);
  }

  getTypeDropDown() {
    if (this.expirations.length > 6) {
      return 'expirations';
    }
    return '';
  }

  switchMode() {
    this.commonCalculator.switchMode();
  }

  returnRegion($event) {
    const region = $event.region;
    this.returnRegionEvent.emit({region: region});
  }

  showSpinner() {
    this.isLoading = true;
    this.spinner.show('probabilityCalculatorSpinner');
  }

  openDropdown(index: number) {
    this.dropdown.toArray().forEach((item, i) => {
      if (i !== index) {
        item.close();
      }
    });
    this.openDropdownEvent.emit();
  }

  closeProbabilityDropdown() {
    this.dropdown.toArray().forEach((item) => {
      item.close();
    });
  }

  public inputHandler(text: string): void {
    this.inputChanged.next(text)
  }

  private _getFutureExpirations() {
    return new Promise((resolve, reject) => {
      this._calculatorsService.getFutureExpirations(this.id).then(response => {
        this.futureExpirations = response;
        resolve(response);
      });
    });
  }

  private _fillParameters($event: { isEod: boolean, id: string, optionCode?: string }) {
    this.symbNotFound = false;
    if ($event.id) {
      this.isLoading = true;
      this.spinner.show('probabilityCalculatorSpinner');
      this.id = $event.id;
      this.isEod = $event.isEod;
      if (this.isFuturesMonitor) {
        this._getFutureExpirations().then((futureExpirations: string[]) => {
          if (!this.futExpDate && futureExpirations) {
            this.futExpDate = futureExpirations[0];
          }
          this._getOptExpirations($event.id, this.futExpDate, $event.isEod).then(() => {
            this._getFutParameters({...$event, id: $event?.optionCode ? $event.optionCode : this.id}).then((data: HttpResponse<any>) => {
              this._fillParametersValues(data.body);
              this._getFutVoals().subscribe(value => {
                this.setVola(value);
                if (this.expirations.length === 0 && !this.symbNotFound) {
                  this.showMessageEvent.emit({message: 'Data not found', type: 'error'});
                } else {
                  if (!this.symbNotFound) {
                    this.calculate();
                  }
                }
              });
            });
          }).catch(() => {
            this.symbNotFound = true;
            this.symbolNotFound();
          }).finally(() => this.hideSpinner());
        });
      } else {
        this._getExpirations().then(() => {
          this.hideSpinner();
          this._getParameters($event).then(data => {
            this._fillParametersValues(data);
            this._getVolas().subscribe(value => {
              this.setVola(value);
              if (this.expirations.length === 0 && !this.symbNotFound) {
                this.showMessageEvent.emit({message: 'Data not found', type: 'error'});
              } else {
                if (!this.symbNotFound) {
                  this.calculate();
                }
              }
            });
          }, () => {
            console.warn('smth went wrong');
          });
        });
      }
    }
  }

  private _getFutParameters(event: { isEod: boolean, id: string }) {
    return new Promise((resolve, reject) => {
      this._calculatorsService.getFutProbabilityCalculatorParameters(event.id, this.futExpDate)
        .toPromise()
        .then(data => {
          resolve(data);
        })
        .catch(reject);
    });
  }

  private _getOptExpirations(underlyingId, futExpDate, isEod) {
    return new Promise((resolve) => {
      this._calculatorsService.getOptFutureExpirations(underlyingId, futExpDate, isEod).then(response => {
        this.expirations = response.map(expiration => {
          return {
            expTime: expiration.expDate.substring(11, 16),
            daysToExp: expiration.daysToExp,
            longExpDate: expiration.expDate,
            expDate: expiration.expDate.substring(0, 10),
            hours: expiration.hours,
            minutes: expiration.minutes
          };
        });
        resolve(response);
      });
    });
  }

  private _getExpirations() {
    return new Promise((resolve, reject) => {
      this._calculatorsService.getExpirations(this.id, this._isEod()).then(response => {
        this.expirations = response.map(expiration => {
          return {
            expTime: expiration.expDate.substring(11, 16),
            daysToExp: expiration.daysToExp,
            longExpDate: expiration.expDate,
            expDate: expiration.expDate.substring(0, 10),
            hours: expiration.hours,
            minutes: expiration.minutes
          };
        });
        resolve(response);
      });
    });
  }

  private _fillParametersValues(parameters) {
    if (parameters) {
      this.parameters = parameters;
      this.price = +parameters.price.toFixed(2);
      this.expDate = {
        expTime: parameters.expDate?.substring(11, 16),
        daysToExp: parameters.daysToExp,
        daysToExpRt: parameters.daysToExpRt,
        longExpDate: parameters.expDate,
        expDate: parameters.expDate?.substring(0, 10),
        hours: parameters.hours,
        minutes: parameters.minutes
      };
      this.expTime = parameters.expDate?.substring(11, 16);
      this.daysToExp = parameters.daysToExp;
      this.hours = parameters.hours;
      this.minutes = parameters.minutes;
      this.longExpDate = parameters.expDate;
      // this.vola = (parameters.Vola * 100).toFixed(2);
      this.rate = parameters.rate?.toFixed(4);
      this.lastDividendDate = parameters.lastDividendDate?.substring(0, 10);
      this.lastDividendAmount = parameters.lastDividendAmount;
      if (this.lastDividendAmount !== 0.0 && this.lastDividendAmount !== null) {
        this.lastDividendAmount = this.lastDividendAmount?.toFixed(2);
      }
      this.dividendFrequency = parameters.dividendFrequency;
      if (this.dividendFrequency === 1) {
        this.dividendFrequencyName = 'Annually';
      }
      if (this.dividendFrequency === 2) {
        this.dividendFrequencyName = 'Semiannually';
      }
      if (this.dividendFrequency === 4) {
        this.dividendFrequencyName = 'Quarterly';
      }
      if (this.dividendFrequency === 12) {
        this.dividendFrequencyName = 'Monthly';
      }
      this.regionId = parameters.regionId;
      this._yield = (parameters.Yield * 100)?.toFixed(2);
      this.volaTerm = 0;
      this.volaType = 'ATM';
      this.volaString = 'ATM Volatility';
      this.stockType = parameters.stockType;
    }
    if (
      this.price === 0 &&
      this.priceStrike === null &&
      this.daysToExp === 0 &&
      this.hours === 0 &&
      this.minutes === 0 &&
      this.rate === 0 &&
      this.lastDividendAmount === null &&
      this.dividendFrequency === null &&
      (this._yield === 0.00 || this._yield === null) &&
      (this.regionId === null || this.regionId === 0)) {
      this.symbNotFound = true;
      this.symbolNotFound();
    }
  }

  private _selectCustomExpiration() {
    this.expDate = this._customDate;
  }

  private _selectCustomVola() {
    this.volaString = this._customVola.volaString;
    this.volaTerm = this._customVola.volaTerm;
    this.volaType = this._customVola.volaType;
  }

  private _isEod() {
    return this.isEod;
  }
}
